import { createSlice } from '@reduxjs/toolkit';
import { userActions } from './user.actions';

export interface userState {
  value: any;
  status: 'idle' | 'loading' | 'failed';
}

interface UsersListState {
  usersListData: any[];
  pagination: any;
  error: string;
  loading: boolean;
}

const initialState: UsersListState = {
  usersListData: [],
  pagination: {},
  error: "",
  loading: false,
};


const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
       // -------- cases of Get all users api data -------
       .addCase(userActions.getUsersAction.pending, (state, action) => {
        state.error = "";
        state.loading = true;
      })
      .addCase(userActions.getUsersAction.fulfilled, (state, action) => {
        if (action.payload.data.status===200) {
          state.loading = false;
          state.usersListData= action.payload.data.data;
          console.log("usersListData",state.usersListData)
          state.pagination={...action.payload.data.pagination}
          state.error = "";
        } else {
          state.usersListData = [];
          state.pagination = {};
          state.loading = false;
          state.error = "unable to fetch users List.";
        }
      })
      .addCase(userActions.getUsersAction.rejected, (state, action:any) => {
        state.loading = false;
        state.usersListData = [];
        state.pagination = {};
        state.error = action?.payload?.data?.message || "";
      });
  },
  
});

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
// export const token = (state: RootState) => state.login.token;


export default userSlice.reducer;
